import { appConfig } from '../../../../../../../config/customization';

const iconSize = 55;

const wheelButtonPositioning = (top, left) => ({
  bottom: `calc(${top}px + 68%)`,
  left: `calc(${left}px + 50%)`,
  zIndex: 2
});

const hoverTrapezoid = (translateX, translateY, rotateZ) => ({
  transform: `translateX(${translateX}px) translateY(${translateY}px) rotateZ(${rotateZ}deg) perspective(200px) rotateX(55deg)`
});

const label = (translateX, translateY) => ({
  transform: `translateX(${translateX}px) translateY(${translateY}px)`,
  zIndex: 4,
  position: 'absolute',
  textOverflow: 'ellipsis',
  overflow: 'hidden'
});

const content = (translateX, translateY, width, height) => ({
  transform: `translateX(${translateX}px) translateY(${translateY}px)`,
  zIndex: 4,
  position: 'absolute',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  width,
  height
});

export default {
  container: {
    position: 'absolute',
    width: 0,
    height: 0
  },
  hoverDiv: {
    width: 100,
    height: 180,
    zIndex: 5,
    position: 'absolute'
  },
  button: {
    height: 280,
    pointerEvents: 'none'
  },
  iconContainer: {
    height: iconSize,
    width: iconSize,
    backgroundColor: appConfig.colors.white,
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexShrink: 0
  },
  icon: {
    maxHeight: '75%',
    maxWidth: '75%'
  },
  content: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    flexDirection: 'column'
  },
  description: {
    lineHeight: '15px',
    paddingTop: '3px',
    whiteSpace: 'normal',
    display: 'block',
    maxWidth: '100%'
  },
  wheelButtonPositioning0: wheelButtonPositioning(-130, -205),
  wheelButtonPositioning1: wheelButtonPositioning(60, -205),
  wheelButtonPositioning2: wheelButtonPositioning(150, -105),
  wheelButtonPositioning3: wheelButtonPositioning(150, 85),
  wheelButtonPositioning4: wheelButtonPositioning(60, 175),
  wheelButtonPositioning5: wheelButtonPositioning(-130, 175),
  hover0: hoverTrapezoid(120, 15, 68),
  hover1: hoverTrapezoid(120, 80, 115),
  hover2: hoverTrapezoid(120, 80, 160),
  hover3: hoverTrapezoid(60, 80, -160),
  hover4: hoverTrapezoid(60, 80, -115),
  hover5: hoverTrapezoid(60, 15, -68),
  tag0: label(70, 60),
  tag1: label(110, 70),
  tag2: label(180, 60),
  tag3: label(70, 60),
  tag4: label(140, 70),
  tag5: label(180, 60),
  content0: content(85, 70, 100, 100),
  content1: content(65, 105, 135, 105),
  content2: content(100, 90, 120, 85),
  content3: content(60, 90, 120, 85),
  content4: content(80, 105, 135, 105),
  content5: content(95, 70, 100, 100)
};
